import React from 'react';
import { Box, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { BasicCodeCombo } from '../core/BasicCodeCombo';

type Props = {
  scenarioCode: string;
  sourceCode: string;
  filename: string;
  scenarios: any[];
  sources: any[];
  loading?: boolean;
  dirtyCount?: number;
  onScenarioChange: (value: string) => void;
  onSourceChange: (value: string) => void;
  onFilenameChange: (value: string) => void;
  onAddRow: () => void;
  onSave: () => void;
  onClear: () => void;
};

class BieEntryFilterBar extends React.Component<Props> {
  render() {
    const p = this.props;
    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', md: 'center' }} spacing={2} sx={{ mb: 2 }}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>BIE Entry Controls</Typography>
            <Typography variant="caption" color="text.secondary">Manual spreadsheet-style BIE entry with combo fields and DataGrid editing.</Typography>
          </Box>
          <Stack direction="row" spacing={1}>
            <Button variant="outlined" startIcon={<ClearIcon />} onClick={p.onClear} disabled={p.loading}>Clear</Button>
            <Button variant="outlined" startIcon={<AddIcon />} onClick={p.onAddRow} disabled={p.loading}>Add Row</Button>
            <Button variant="contained" startIcon={<SaveIcon />} onClick={p.onSave} disabled={p.loading || !p.dirtyCount}>Save {p.dirtyCount ? `(${p.dirtyCount})` : ''}</Button>
          </Stack>
        </Stack>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 3 }}><BasicCodeCombo label="Scenario" items={p.scenarios || []} value={p.scenarioCode || ''} onChange={(v:string)=>p.onScenarioChange(String(v||'').toUpperCase())} disabled={p.loading}/></Grid>
          <Grid size={{ xs: 12, md: 3 }}><BasicCodeCombo label="Source" items={p.sources || []} value={p.sourceCode || ''} onChange={(v:string)=>p.onSourceChange(String(v||'').toUpperCase())} disabled={p.loading}/></Grid>
          <Grid size={{ xs: 12, md: 6 }}><TextField size="small" label="Filename" value={p.filename || ''} onChange={(e)=>p.onFilenameChange(e.target.value)} disabled={p.loading} fullWidth /></Grid>
        </Grid>
      </Paper>
    );
  }
}
export default BieEntryFilterBar;
